import { useEffect, useState } from "react";
import { api } from "../api/apiClient";

interface Props {
  templateId: string;
  imageKey: string | null;
  alt: string;
  size?: number;
}

export function BouquetTemplateThumb({ templateId, imageKey, alt, size = 56 }: Props) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let revoked: string | null = null;
    let cancelled = false;
    if (!imageKey) {
      setUrl(null);
      return;
    }
    void api.fetchBouquetTemplateImageBlobUrl(templateId).then((blobUrl) => {
      if (cancelled) {
        if (blobUrl) URL.revokeObjectURL(blobUrl);
        return;
      }
      revoked = blobUrl;
      setUrl(blobUrl);
    });
    return () => {
      cancelled = true;
      if (revoked) URL.revokeObjectURL(revoked);
    };
  }, [templateId, imageKey]);

  const dim = `${size}px`;
  if (!imageKey) {
    return (
      <div
        aria-hidden
        style={{
          width: dim,
          height: dim,
          borderRadius: "var(--radius-md)",
          background: "var(--color-surface-muted)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "var(--color-text-muted)",
          fontSize: 11,
          flexShrink: 0,
        }}
      >
        No photo
      </div>
    );
  }
  if (!url) {
    return (
      <div
        aria-hidden
        style={{
          width: dim,
          height: dim,
          borderRadius: "var(--radius-md)",
          background: "var(--color-surface-muted)",
          flexShrink: 0,
        }}
      />
    );
  }
  return (
    <img
      src={url}
      alt={alt}
      style={{
        width: dim,
        height: dim,
        objectFit: "cover",
        borderRadius: "var(--radius-md)",
        flexShrink: 0,
      }}
    />
  );
}
